document.addEventListener('DOMContentLoaded', () => {

  const drawer = document.getElementById('cart-drawer');
  const overlay = document.querySelector('.cart-overlay');
  const closeBtn = drawer?.querySelector('.close-cart');
  const cartItems = drawer?.querySelector('.js-cart-items');
  const cartTotal = drawer?.querySelector('.js-cart-total');
  const upsellsContainer = drawer?.querySelector('.js-cart-upsells');
  const upsellList = upsellsContainer?.querySelector('.upsell-products');

  const applyBtn = document.getElementById("apply-discount");
const discountInput = document.getElementById("discount-code");
const discountMsg = document.getElementById("discount-msg");

applyBtn?.addEventListener("click", () => {
  const code = discountInput.value.trim();

  if (!code) {
    discountMsg.textContent = "Please enter a discount code.";
    discountMsg.style.color = "red";
    return;
  }

  discountMsg.textContent = "Applying discount...";
  discountMsg.style.color = "#555";

  // Apply discount and go to checkout
  window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
});


function updateFreeShipping(cart) {
  const threshold = window.free_shipping_threshold;
  if (!threshold) return;

  const bar = document.querySelector(".js-free-shipping-bar");
  const msg = document.querySelector(".js-free-shipping-message");
  const truck = document.querySelector(".js-free-shipping-truck");

  if (!bar || !msg || !truck) return;

 

  const total = cart.total_price;
  const remaining = threshold - total;
 

  if (total >= threshold) {
    bar.style.width = "100%";
    truck.style.left = "100%";
    msg.textContent = "🎉 You’ve unlocked FREE Shipping!";
  } else {
    const percent = Math.min((total / threshold) * 100, 100);
    bar.style.width = percent + "%";
    truck.style.left = percent + "%";

   msg.textContent =
  `Add ${formatMoney(remaining)} more to get FREE Shipping`;

  }
}


  /* ======================
     UTIL – FORMAT MONEY
  ====================== */
  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents);
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'INR'
    });
  }

  async function getCartData() {
    return fetch('/cart.js').then(r => r.json());
  }

  /* ======================
     GET VARIANT FROM HANDLE
  ====================== */
  async function getVariantFromHandle(handle) {
    const res = await fetch(`/products/${handle}.js`);
    const product = await res.json();
    return product.variants[0].id;
  }

  /* ======================
     AUTO FREE GIFT LOGIC
  ====================== */
  async function autoGiftBundle() {
    const cart = await getCartData();

    let freeGiftHandle = null;
    let buyQtyRequired = null;
    let freeVariantId = null;

    let totalQtyExcludingGifts = 0;

    cart.items.forEach(item => {
      const mf = item.properties && item.properties._metafields
        ? item.properties._metafields
        : null;

      const isGift = item.properties && item.properties._is_free_gift === "true";

      if (mf) {
        if (mf["custom.free_gift_product"] && !freeGiftHandle)
          freeGiftHandle = mf["custom.free_gift_product"];

        if (mf["custom.buy_quantity"] && !buyQtyRequired)
          buyQtyRequired = parseInt(mf["custom.buy_quantity"]);
      }

      if (!isGift) totalQtyExcludingGifts += item.quantity;
    });

    if (!freeGiftHandle || !buyQtyRequired) return false;

    try {
      freeVariantId = await getVariantFromHandle(freeGiftHandle);
    } catch (e) {
      console.warn("Gift product not found:", freeGiftHandle);
      return false;
    }

    const giftLine = cart.items.find(i => i.variant_id == freeVariantId);
    const giftExists = !!giftLine;

    /* ======================
       ADD FREE GIFT
    ====================== */
    if (totalQtyExcludingGifts >= buyQtyRequired && !giftExists) {
      await fetch('/cart/add.js', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: freeVariantId,
          quantity: 1,
          properties: {
            _is_free_gift: "true",
            unique: "gift-" + Date.now() // prevent Shopify merging
          }
        })
      });
      return true;
    }

    /* ======================
       REMOVE FREE GIFT
    ====================== */
    if (totalQtyExcludingGifts < buyQtyRequired && giftExists) {
      await fetch('/cart/change.js', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: giftLine.key,
          quantity: 0
        })
      });
      return true;
    }

    return false;
  }

  /* ======================
     DRAWER CONTROLS
  ====================== */
  function closeDrawer() {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    setTimeout(() => drawer.classList.add('inactive'), 300);
  }

  function openDrawer() {
    drawer.classList.remove('inactive');
    drawer.classList.add('active');
    overlay.classList.add('active');
    updateDrawer();
  }

  function updateCartCount(cart) {
  const countEl = document.querySelector('.js-cart-count');
  if (!countEl) return;
  countEl.textContent = cart.item_count;
}


  window.openDrawer = openDrawer;

  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);

  /* ======================
     RENDER CART DRAWER
  ====================== */
  async function updateDrawer() {
    cartItems.innerHTML = '<p class="loader">Loading...</p>';

    try {
      const cart = await getCartData();
      updateCartCount(cart);
     updateFreeShipping(cart);

      let html = ``;

      if (!cart.items.length) {
        cartItems.innerHTML = `
          <div class="cart-empty">
            <p>Your cart is empty.</p>
            <a href="/" class="btn-continue-shopping">Continue Shopping</a>
          </div>`;
        cartTotal.textContent = formatMoney(0);
        return;
      }

      html += `
        <div class="cart-note">
          <label>Add a note for your order:</label>
          <textarea id="CartSpecialInstructions">${cart.note || ''}</textarea>
        </div>`;

      cart.items.forEach(item => {
        const original = item.original_line_price;
        const final = item.final_line_price;

        const discountsHTML =
          item.discounts?.map(d => `
            <p class="discount-note">-${formatMoney(d.amount)} (${d.title})</p>
          `).join('') || '';

        html += `
          <div class="cart-item" data-key="${item.key}">
            <img src="${item.image}" class="cart-item-img">

            <div class="cart-item-info">
              <div class="cart-item-header">
              <p class="cart-item-title">${item.title}</p>

              <p class="cart-price">
                ${original > final ? `<span class="price-original">${formatMoney(original)}</span>` : ''}
                <span class="price-final">${formatMoney(final)}</span>
              </p>
              </div>

              ${discountsHTML}

              <div class="qty-control">
                <button class="decrease">−</button>
                <input type="number" min="1" value="${item.quantity}" class="item-qty">
                <button class="increase">+</button>
                <span class="delete-item">×</span>
              </div>
            </div>
          </div>`;
      });

      cartItems.innerHTML = html;
      cartTotal.textContent = formatMoney(cart.total_price);

      /* ======================
   CART NOTE SAVE
====================== */
const noteInput = document.getElementById("CartSpecialInstructions");

if (noteInput) {
  let noteTimer;

  noteInput.addEventListener("input", () => {
    clearTimeout(noteTimer);

    noteTimer = setTimeout(async () => {
      try {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            note: noteInput.value
          })
        });
      } catch (err) {
        console.error("Failed to save cart note", err);
      }
    }, 500); // debounce for performance
  });
}


       /* =============================
   BUNDLE DISCOUNT (THEME UI)
============================= */
let bundleItems = cart.items.filter(i =>
  i.properties && i.properties._bundle_item === "true"
);

// Remove existing rows if already added
document.querySelector('.bundle-subtotal-row')?.remove();
document.querySelector('.bundle-discount-row')?.remove();

if (bundleItems.length > 0) {
  const discountPercent =
    parseFloat(bundleItems[0]?.properties?._bundle_discount_percent) || 0;

  if (discountPercent > 0) {
    const subtotal = cart.total_price; // original subtotal
    const discountAmount = subtotal * (discountPercent / 100);
    const finalTotal = subtotal - discountAmount;

    const cartTotalRow = document.querySelector('.cart-total');
    const cartTotalValue = document.querySelector('.js-cart-total');

    if (!cartTotalRow || !cartTotalValue) return;

    // Insert SUBTOTAL above total
    cartTotalRow.insertAdjacentHTML(
      'beforebegin',
      `
      <div class="bundle-subtotal-row">
        <span>Subtotal</span>
        <strong>${formatMoney(subtotal)}</strong>
      </div>
      `
    );

    // Insert DISCOUNT above total
    cartTotalRow.insertAdjacentHTML(
      'beforebegin',
      `
      <div class="bundle-discount-row">
        <span>Bundle Discount (${discountPercent}%)</span>
        <strong>- ${formatMoney(discountAmount)}</strong>
      </div>
      `
    );

    // Update final total value
    cartTotalValue.textContent = formatMoney(finalTotal);
  }
}



      /* ======================
         QTY CONTROLS
      ====================== */
      document.querySelectorAll('.cart-item').forEach(el => {
        const key = el.dataset.key;
        const qtyInput = el.querySelector('.item-qty');

        el.querySelector('.increase').onclick =
          () => updateQty(key, parseInt(qtyInput.value) + 1);

        el.querySelector('.decrease').onclick =
          () => updateQty(key, parseInt(qtyInput.value) - 1);

        qtyInput.onchange =
          () => updateQty(key, parseInt(qtyInput.value));

        el.querySelector('.delete-item').onclick =
          () => removeItem(key);
      });

      /* ======================
         UPSSELL FIX  
         (IGNORE FREE GIFT PRODUCT)
      ====================== */
      let realProduct = cart.items.find(item =>
        !item.properties || item.properties._is_free_gift !== "true"
      );

      if (realProduct) {
        loadUpsells(realProduct.product_id);
      } else {
        upsellsContainer.classList.add("hidden");
      }

      /* ======================
         APPLY FREE GIFT LOGIC
      ====================== */
      const changed = await autoGiftBundle();
      if (changed) return updateDrawer();

    } catch (err) {
      console.error("Drawer update failed:", err);
      cartItems.innerHTML = '<p>Error loading cart.</p>';
    }
  }

  /* ======================
     CART ACTIONS
  ====================== */
  async function updateQty(key, qty) {
    if (qty < 1) qty = 1;

    await fetch('/cart/change.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    });

    await autoGiftBundle();
    updateDrawer();
  }

  async function removeItem(key) {
    await fetch('/cart/change.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 })
    });

    await autoGiftBundle();
    updateDrawer();
  }

  /* ======================
     LOAD UPSELL PRODUCTS
  ====================== */
  async function loadUpsells(productId) {
    if (!upsellsContainer || !upsellList) return;

    const res = await fetch(
      `/recommendations/products.json?product_id=${productId}&limit=3`
    );
    const data = await res.json();

    if (!data.products?.length) {
      upsellsContainer.classList.add("hidden");
      return;
    }

    upsellList.innerHTML = data.products.map(p => `
      <div class="upsell-item">
        <img src="${p.featured_image}">
        <p>${p.title}</p>
        <strong>${formatMoney(p.price)}</strong>
        <button data-id="${p.variants[0].id}">Add</button>
      </div>
    `).join('');

    upsellsContainer.classList.remove("hidden");

    upsellList.querySelectorAll('button').forEach(btn => {
      btn.onclick = async () => {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.id, quantity: 1 })
        });
        updateDrawer();
      };
    });
  }

  /* ======================
     PRODUCT PAGE AJAX ADD
  ====================== */
  const productForm = document.querySelector('form[action="/cart/add"]');
  const addBtn = document.getElementById("AddToCartBtn");

  if (productForm && addBtn) {
    addBtn.addEventListener("click", async e => {
      e.preventDefault();

      addBtn.disabled = true;
      addBtn.classList.add("loading");

      const formData = new FormData(productForm);

      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "X-Requested-With": "XMLHttpRequest" },
          body: formData
        });

        await autoGiftBundle();
        openDrawer();

      } catch (err) {
        console.error("Add to cart failed:", err);
      }

      addBtn.disabled = false;
      addBtn.classList.remove("loading");
    });
  }

  updateDrawer();
});
